import React from 'react';

import { Box, makeStyles, Typography } from '@material-ui/core';
import dynamic from 'next/dynamic';
import { FormattedMessage } from 'react-intl';

import { GameTeaser } from 'services/api/definitions/collections.definitions';

import AboutGame, { AboutGameProps } from './AboutGame/AboutGame';

const GameSection = dynamic(import('components/@game-detail/Section'));

interface Props {
  details?: AboutGameProps;
  recommendedGames?: GameTeaser[];
  showTitle?: boolean;
}

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(10),
  },
}));

const About = ({ recommendedGames, details, showTitle = false }: Props) => {
  const classes = useStyles();

  return (
    <Box mx={4} display="flex" flexDirection="column">
      {showTitle && (
        <Typography className={classes.title} variant="h5" component="h2" color="textPrimary">
          <FormattedMessage id="game.details.tabs.about" />
        </Typography>
      )}
      {details && <AboutGame {...details} />}
      {!!recommendedGames?.length && (
        <>
          <Typography className={classes.title} variant="h5" component="h2" color="textPrimary">
            <FormattedMessage id="game.you_may_also_like.title" />
          </Typography>
          <GameSection
            id="recommended_games"
            variant="detail"
            data={recommendedGames}
            disablePadding
          />
        </>
      )}
    </Box>
  );
};

export default About;
